module.exports = __webpack_public_path__ + "static/media/coin_hllc.cf1c0cb4.png";